export const en = {
   hero: {
      title: 'About AKAS',
      description:
         "AKAS is Cambodia's leading provider of cloud-based business ERP solutions, helping businesses of all sizes streamline operations, increase efficiency, and drive growth through innovative software.",
   },
   mission: {
      title: 'Our Mission',
      description:
         'To empower businesses with accessible, innovative cloud solutions that drive efficiency, growth, and digital transformation.',
   },
   story: {
      title: 'Our Story',
      paragraphs: [
         'Founded in Phnom Penh in 2024, AKAS was created to make powerful business software accessible to organizations of all sizes—without the high cost of international platforms or the limitations of spreadsheets. Built as a modular, cloud-based business management suite, AKAS combines practical technology, local expertise, and hands-on implementation to help businesses operate smarter and scale with confidence.',

         'What began with HRMS has evolved into an integrated platform connecting the entire business lifecycle: from recruitment to payroll, lead management to customer receipts, purchasing to accounts payable, and operational transactions to the general ledger. With multilingual interfaces, visual workflow automation, and support for local payroll and payment requirements, AKAS brings business processes together in one connected system—designed around the realities of doing business in Cambodia and built to grow with each organization.',

         '**With AKAS, businesses gain more than software—they gain a foundation for growth.** By connecting people, processes, and financial data in one platform, AKAS helps organizations reduce manual work, improve visibility, strengthen control, and make better decisions. Our mission is to give every growing business the tools, guidance, and confidence to operate like a well-connected enterprise—without enterprise-level complexity or cost.',
      ],
   },
   valuesTitle: 'Our Values',
   values: [
      {
         title: 'Innovation',
         description:
            'We continuously evolve our solutions with the latest technologies to meet the changing needs of businesses.',
      },
      {
         title: 'Reliability',
         description:
            'Our secure, stable cloud infrastructure ensures your business data is always accessible and protected.',
      },
      {
         title: 'Close support',
         description:
            'Workflows, customization feature, languages, and day-to-day support are part of the product — not a distant add-on pack.',
      },
      {
         title: 'Client Success',
         description:
            'We measure our success by the success of our clients, providing ongoing support and training to maximize ROI.',
      },
   ],
   team: {
      title: 'Our Team',
      intro: 'Led by experienced software developers and business consultants, our team combines technical expertise with a practical understanding of how businesses actually operate.',
      members: [
         {
            name: 'CHEAM Savun',
            position: 'CTO (Consultant)',
            bio: 'Over 20 years working in IT and Software development',
         },
      ],
   },
   cta: {
      title: 'Ready to transform your business?',
      description:
         'Contact us today to learn how AKAS solutions can help your organization thrive.',
      button: 'Contact Us',
   },
};

export type Copy = typeof en;

export const km: Copy = {
   hero: {
      title: 'អំពី AKAS',
      description:
         'AKAS ជាអ្នកផ្តល់ដំណោះស្រាយគ្រប់គ្រងអាជីវកម្មលើពពក(Cloud ERP)ឈានមុខគេនៅកម្ពុជា។ យើងជួយអាជីវកម្មគ្រប់ទំហំឱ្យប្រតិបត្តិការរលូន បង្កើនប្រសិទ្ធភាព និងរីកចម្រើនជាមួយគ្នា តាមរយៈកម្មវិធីច្នៃប្រឌិតថ្មីរបស់យើង។',
   },
   mission: {
      title: 'បេសកកម្មរបស់យើង',
      description:
         'យើងចង់ឱ្យអាជីវកម្មគ្រប់ប្រភេទអាចប្រើដំណោះស្រាយលើពពក(on cloud)ដែលងាយស្រួលប្រើ និងច្នៃប្រឌិតថ្មី ដើម្បីបង្កើនប្រសិទ្ធភាព ជំរុញកំណើន និងឆ្ពោះទៅរកការផ្លាស់ប្តូរឌីជីថល។',
   },
   story: {
      title: 'រឿងរ៉ាវរបស់យើង',
      paragraphs: [
         'AKAS បានចាប់កំណើតនៅភ្នំពេញក្នុងឆ្នាំ 2024 ដោយមានគោលដៅធ្វើឱ្យកម្មវិធីគ្រប់គ្រងអាជីវកម្មដ៏មានឥទ្ធិពល ក្លាយជារឿងដែលអង្គភាពគ្រប់ទំហំអាចប្រើបានដោយមិនចាំបាច់ចំណាយខ្ពស់ដូចវេទិកាអន្តរជាតិ ហើយក៏មិនជាប់កំណត់នៅក្នុងការប្រើ Spreadsheets ដូចមុន។ យើងបង្កើត AKAS ជាប្រព័ន្ធគ្រប់គ្រងអាជីវកម្មលើពពក (on cloud) ដែលអាចជ្រើសរើសម៉ូឌុល(module)តាមតម្រូវការបាន ដោយផ្សំបច្ចេកវិទ្យាអនុវត្តពិត ជំនាញក្នុងស្រុក និងការអនុវត្តផ្ទាល់ដៃ ដើម្បីឱ្យអាជីវកម្មដំណើរការឆ្លាតវៃ និងរីកចម្រើនដោយទំនុកចិត្ត។',
         'ចាប់ផ្តើមពីប្រព័ន្ធគ្រប់គ្រងធនធានមនុស្ស ឥឡូវAKASបានក្លាយជាវេទិកាតែមួយដែលភ្ជាប់ដំណើរការទាំងមូលនៃអាជីវកម្ម៖ ពីការជ្រើសរើសបុគ្គលិកដល់ការបើកប្រាក់ខែ ពីការគ្រប់គ្រងឱកាសលក់ដល់ចេញបង្កាន់ដៃជូនអតិថិជន ពីការបញ្ជាទិញដល់គណនីត្រូវបង់ និងពីប្រតិបត្តិការប្រចាំថ្ងៃដល់សៀវភៅគណនីទូទៅ។ ប្រព័ន្ធមានច្រើនភាសា មានការរៀបចំដំណើរការការងារតាមរូបដ្យាក្រាម និងគាំទ្រការទូទាត់ក្នុងស្រុក — ទាំងអស់នៅក្នុងប្រព័ន្ធតែមួយដែលភ្ជាប់គ្នា។ យើងរចនាវាឡើងដោយផ្អែកលើការធ្វើអាជីវកម្មពិតនៅកម្ពុជា ហើយឱ្យវារីកធំទៅតាមអង្គភាពនីមួយៗ។',
         '**ជាមួយAKAS អ្នកមិនមែនទទួលបានតែកម្មវិធីsoftwareនោះទេ — តែអ្នកទទួលបានមូលដ្ឋានរឹងមាំសម្រាប់ការរីកចម្រើនអាជីវកម្មរបស់អ្នក។** ពេលបុគ្គលិកដំណើរការការងារនិងទិន្នន័យហិរញ្ញវត្ថុស្ថិតក្នុងប្រព័ន្ធតែមួយ ការងារដោយដៃថយចុះ ព័ត៌មានកាន់តែច្បាស់ ការគ្រប់គ្រងកាន់តែណែន ហើយការសម្រេចចិត្តកាន់តែត្រូវចំណុច។ បេសកកម្មរបស់យើង គឺផ្តល់ឱ្យអាជីវកម្មដែលកំពុងរីកចម្រើនគ្រប់ប្រភេទនូវឧបករណ៍ ការណែនាំ និងទំនុកចិត្ត ដើម្បីដំណើរការបានដូចសហគ្រាសខ្នាតធំដែលភ្ជាប់គ្នាបានល្អ — ដោយមិនជួបភាពស្មុគស្មាញ ឬចំណាយកម្រិតខ្ពស់នោះទេ។',
      ],
   },
   valuesTitle: 'តម្លៃរបស់យើង',
   values: [
      {
         title: 'ការច្នៃប្រឌិត',
         description:
            'យើងបន្តអភិវឌ្ឍដំណោះស្រាយដោយប្រើបច្ចេកវិទ្យាថ្មីៗ ដើម្បីឆ្លើយតបនឹងតម្រូវការអាជីវកម្មដែលផ្លាស់ប្តូរជានិច្ច។',
      },
      {
         title: 'ភាពគួរឱ្យទុកចិត្ត',
         description:
            'ហេដ្ឋារចនាសម្ព័ន្ធលើពពក(on cloud)របស់យើងមានសុវត្ថិភាព និងស្ថិរភាព ដូច្នេះទិន្នន័យអាជីវកម្មរបស់អ្នកតែងតែចូលប្រើបាន និងមានការការពារ។',
      },
      {
         title: 'ជំនួយជិតស្និទ្ធ',
         description:
            'តំណើការការងារស្វ័យប្រវត្តិ ការកែប្រែទម្រង់ទិន្នន័យ ភាសា និងការជួយប្រចាំថ្ងៃ សុទ្ធតែបានបញ្ចូលទៅក្នុងផលិតផលតែម្តង — មិនមែនជាកញ្ចប់បន្ថែមដាច់ដោយឡែកទេ។',
      },
      {
         title: 'ជោគជ័យរបស់អតិថិជន',
         description:
            'យើងវាស់ជោគជ័យរបស់យើងតាមការជោគជ័យរបស់អតិថិជន ហើយបន្តផ្តល់ការគាំទ្រ និងការបណ្តុះបណ្តាល ដើម្បីឱ្យការវិនិយោគរបស់អ្នកទទួលបានផលច្រើនបំផុត។',
      },
   ],
   team: {
      title: 'ក្រុមការងាររបស់យើង',
      intro: 'ក្រុមការងាររបស់យើងដឹកនាំដោយអ្នកអភិវឌ្ឍន៍កម្មវិធីដែលមានបទពិសោធន៍ និងអ្នកប្រឹក្សាអាជីវកម្ម។ យើងផ្សំជំនាញបច្ចេកទេសជាមួយការយល់ដឹងជាក់ស្តែងអំពីរបៀបដែលអាជីវកម្មដំណើរការពិត។',
      members: [
         {
            name: 'CHEAM Savun',
            position: 'នាយកបច្ចេកវិទ្យា (អ្នកប្រឹក្សា)',
            bio: 'មានបទពិសោធន៍ជាង 20 ឆ្នាំក្នុងវិស័យព័ត៌មានវិទ្យា និងការអភិវឌ្ឍន៍កម្មវិធី',
         },
      ],
   },
   cta: {
      title: 'ត្រៀមខ្លួនផ្លាស់ប្តូរអាជីវកម្មរបស់អ្នកហើយឬនៅ?',
      description:
         'ទាក់ទងមកយើងថ្ងៃនេះ ដើម្បីដឹងថាដំណោះស្រាយ AKAS អាចជួយស្ថាប័នរបស់អ្នករីកចម្រើនយ៉ាងដូចម្តេច។',
      button: 'ទាក់ទងមកយើង',
   },
};
